module.exports = __webpack_public_path__ + "static/i-24510f599e93701b829f97888448dbbe.jpg";